var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInfo = function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8.35477C14.25 12.117 11.2229 15.1579 7.5 15.1579C3.77706 15.1579 0.75 12.117 0.75 8.35477C0.75 4.5925 3.77706 1.55164 7.5 1.55164C11.2229 1.55164 14.25 4.5925 14.25 8.35477Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.8512V11.8795",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.82996V6.34058",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgIconInfo;